<template>
    <div>
        <Deposit 
          v-if="islistdeposit" 
          v-bind:setidoutletsetdeposit="setidoutlet"
          v-on:backtodetail="isdetailsetdeposit" 
          v-on:createdeposit="showcreatedeposit"
          v-on:editdeposit="showeditdeposit" 
          ref="listdeposit" 
          @toLayanan="toLayanan"
        />
        <TambahDeposit 
          v-if="iseditdeposit" 
          v-bind:setidoutletsetdeposit="setidoutlet" 
          v-bind:iddeposit="datalistdeposit.iddeposit"
          v-on:gotolistdeposit="showlistdeposits"
        />
        <TambahDeposit 
          v-if="iscreatedeposit" 
          v-bind:setidoutletsetdeposit="setidoutlet"
          v-on:gotolistdeposit="showlistdeposits"
        />
    </div>
</template>

<script>
    import TambahDeposit from "../../deposit/TambahDepositV2";
    import Deposit from "../../deposit/Deposit";
    export default {
        name: "SetDeposit",
        props:['setidoutlet'],
        components: {TambahDeposit, Deposit},
        data(){
            return{
                islistdeposit:false,
                iscreatedeposit:false,
                iseditdeposit:false,

                datalistdeposit:{
                    iddeposit:'',
                }
            }
        },
        mounted(){
            this.showlistdeposit()
        },
        methods:{
            showlistdeposit(){
                this.islistdeposit=true;
                this.iscreatedeposit=false;
                this.iseditdeposit=false;
            },

            showlistdeposits(){
                this.islistdeposit=true;
                this.iscreatedeposit=false;
                this.iseditdeposit=false;
                $('#listdeposit').show()
                this.getlistdeposit()
            },

            showcreatedeposit(){
                this.islistdeposit=true;
                this.iscreatedeposit=true;
                this.iseditdeposit=false;
                $('#listdeposit').hide()
            },

            showeditdeposit(iddeposit){
                this.islistdeposit=true;
                this.iscreatedeposit=false;
                this.iseditdeposit=true;
                $('#listdeposit').hide()
                this.datalistdeposit.iddeposit=iddeposit
            },

            isdetailsetdeposit(){
                this.$emit('isdetail')
            },

            getlistdeposit(){
                this.$refs.listdeposit.getDeposit(true)
	              this.$refs.listdeposit.getLayanan()
	              this.backButtonPressed(this.$refs.listdeposit.back)
            },
	        toLayanan(){
		        $("#listdeposit").hide();
            	this.$emit("toLayanan", this.setidoutlet)
	        }
        }
    }
</script>

<style scoped>

</style>